<template>
    <ul class="flex select-none items-center gap-1 font-sans text-sm">
        <li v-if="pagination.current_page != 1">
            <a
                class="flex h-8 items-center rounded-lg px-2.5 text-gray-500 transition-colors hover:cursor-pointer hover:bg-black/5 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white"
                @click.prevent="change(1)"
            >
                Primeira
            </a>
        </li>
        <li v-if="pagination.current_page > 1">
            <a
                class="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors hover:cursor-pointer hover:bg-black/5 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white"
                @click.prevent="change(pagination.current_page - 1)"
            >
                &lsaquo;
            </a>
        </li>
        <li v-for="page in pages" :key="page">
            <a
                class="flex h-8 min-w-8 items-center justify-center rounded-lg px-2 transition-colors hover:cursor-pointer"
                :class="
                    page == pagination.current_page
                        ? 'bg-indigo-500 font-medium text-white shadow-xs'
                        : 'text-gray-500 hover:bg-black/5 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white'
                "
                @click.prevent="change(page)"
            >
                {{ page }}
            </a>
        </li>
        <li v-if="pagination.current_page < pagination.last_page">
            <a
                class="flex h-8 w-8 items-center justify-center rounded-lg text-gray-500 transition-colors hover:cursor-pointer hover:bg-black/5 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white"
                @click.prevent="change(pagination.current_page + 1)"
            >
                &rsaquo;
            </a>
        </li>
        <li v-if="pagination.current_page != pagination.last_page">
            <a
                class="flex h-8 items-center rounded-lg px-2.5 text-gray-500 transition-colors hover:cursor-pointer hover:bg-black/5 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/10 dark:hover:text-white"
                @click.prevent="change(pagination.last_page)"
            >
                Última
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        pagination: {
            type: Object,
            required: true,
        },
        offset: {
            type: Number,
            default: 4,
        },
    },
    computed: {
        pages() {
            if (!this.pagination.to) {
                return null;
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset * 8;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pages = [];
            for (let page = from; page <= to; page++) {
                pages.push(page);
            }
            return pages;
        },
    },
    methods: {
        change: function (page) {
            this.pagination.current_page = page;
            this.$emit("paginate", page);
        },
    },
};
</script>
